<style lang="less" scoped>
.container-div{
    margin:20px 10px;
    font-size: 15px;
}
.title-div{
    font-weight: 800;
    margin:10px 20px;
    font-size: 16px;
}
.cust-detail-div{
    //height:50px;
    line-height:50px;
}
.cust-detail-title{
    text-align: right;
    margin-right: 100px;
    width:150px;
    
}
.cust-detail-num {
        width: 80%;
        word-break: break-all;
    }
.page-action-btns{
    margin-bottom:10px;
}
.cust-mes{
    margin:0px 0px 14px 18px;
}
.detail-btn{
    height:32px;
    margin-left: 45px;
    margin-top:10px
}
.red-tip{
    color: #F56C6C;
    font-size: 12px;
    margin-left:120px;
}
</style>

<template>
    <div class="detail-container">
        <div class="detail-bread-crumb-div">
            <ZD-bread-crumb :bConfigList="pageConfig.detailBreadCrumb"></ZD-bread-crumb>
        </div>
        <div class="detail-content-div">
            <div class="detail-content-header-div flex">
                <div class="left-page-title-div flex-1">{{pageTitle}}</div>
            </div>
            <div class="detail-content-body-div flex-1">
                <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                    <el-tab-pane label="客户信息" name="first">
                        <div class="container-div">
                            <div class="title-div">用户信息</div>
                            <div class="cust-mes-div">
                                <div class="flex cust-detail-div">
                                    <div class="cust-detail-title">客户编号:</div>
                                    <div>{{detailForm.custNo}}</div>
                                </div>
                                <div class="flex cust-detail-div">
                                    <div class="cust-detail-title">注册日期:</div>
                                    <div>{{detailForm.registerDate}}</div>
                                </div>
                                <div class="flex cust-detail-div">
                                    <div class="cust-detail-title">首次充电:</div>
                                    <div>{{detailForm.firstChargeDate}}</div>
                                </div>
                                <div class="flex cust-detail-div">
                                    <div class="cust-detail-title">手机号:</div>
                                    <div v-if="mobileLength <= 11">{{detailForm.mobile}}</div>
                                </div>
                                <div class="flex cust-detail-div">
                                    <div class="cust-detail-title">openid:</div>
                                    <div v-if="mobileLength > 11">{{detailForm.mobile}}</div>
                                </div>
                                <div class="flex cust-detail-div">
                                    <div class="cust-detail-title">客户标签:</div>
                                    <div>{{detailForm.custTypeName}}</div>
                                </div>
                                <div class="flex cust-detail-div">
                                    <div class="cust-detail-title">客户备注:</div>
                                    <div v-if="remarkShow">{{detailForm.remark}}</div>
                                    <el-input v-if="inputShow" style="width:200px;" size="small" v-model="detailForm.remark"></el-input>
                                    <el-button v-if="btnShow" type="primary" size="small" class="detail-btn" @click="openInput">点击编辑</el-button>
                                    <el-button v-if="editShow" type="primary" size="small" class="detail-btn" @click="toEdit()">编辑</el-button>
                                </div>
                                <div class="flex cust-detail-div">
                                    <div class="cust-detail-title">客户剩余度电:</div>
                                    <div>{{detailForm.balanceValue}}&nbsp;&nbsp;度电</div>
                                </div>
                                <div class="flex cust-detail-div">
                                    <div class="cust-detail-title">公共充电桩IMEI号:</div>
                                    <div class="cust-detail-num">{{detailForm.custPileCode}}</div>
                                </div>
                                <div class="flex cust-detail-div">
                                    <div class="cust-detail-title">私人充电桩IMEI号:</div>
                                    <div>{{detailForm.privatePileCode}}</div>
                                </div>
                                <div class="flex cust-detail-div">
                                    <div class="cust-detail-title">余额:</div>
                                    <div>{{detailForm.balance}}&nbsp;&nbsp;元</div>
                                </div>
                                <!-- <div class="flex cust-detail-div">
                                    <div class="cust-detail-title">客户运营商:</div>
                                    <div>{{detailForm.dealNames}}</div>
                                </div> -->
                            </div>
                        </div>
                        <div class="container-div">
                            <div class="title-div">充电信息</div>
                            <div class="cust-mes-div">
                                <div class="flex cust-detail-div">
                                    <div class="cust-detail-title">充电次数:</div>
                                    <div>{{detailForm.chargeCount}}&nbsp;&nbsp;次</div>
                                </div>
                                <div class="flex cust-detail-div">
                                    <div class="cust-detail-title">充电量:</div>
                                    <div>{{detailForm.chargeVal}}&nbsp;&nbsp;kW·h</div>
                                </div>
                                <div class="flex cust-detail-div">
                                    <div class="cust-detail-title">客户充电费用:</div>
                                    <div>{{detailForm.chargeFee}}&nbsp;&nbsp;元</div>
                                </div>
                                <div class="flex cust-detail-div">
                                    <div class="cust-detail-title">平台抵扣电度:</div>
                                    <div>{{detailForm.chargeElecOnLine}}&nbsp;&nbsp;电度</div>
                                </div>
                                <div class="flex cust-detail-div">
                                    <div class="cust-detail-title">自营抵扣电度:</div>
                                    <div>{{detailForm.chargeElecOffLine}}&nbsp;&nbsp;电度</div>
                                </div>
                                <div class="flex">
                                    <div class="cust-detail-title">消费过的电站:</div>
                                    <div class="cust-detail-num">{{detailForm.stationNames}}</div>
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="客户充值" name="second">
                        <div class="page-action-btns flex">
                            <button class="common-bg-button" @click="handleCustRecharge('1')">充值</button>
                            <button class="common-bg-button" @click="handleCustRecharge('2')">退款</button>
                        </div>
                        <!-- 表格 -->
                        <div class="list-table">
                            <ZD-table :tableColumns="pageConfig.custDetailColumns" :operates="operates" :tableData="tableData" :tableConfig="pageConfig.tableConfig" :selections="selections" v-on:updateSelections="(sels)=>{selections=sels}"></ZD-table>
                        </div>
                        <!-- 分页 -->
                        <div class="list-pagination">
                            <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData"></ZD-pagination>
                        </div>
                        <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="35%">
                            <div class="cust-mes">客户手机：{{detailForm.mobile}}</div>
                            <div class="cust-mes">客户备注：{{detailForm.custRemark}}</div>
                            <div class="cust-mes">最近充值：{{recentInTime}}</div>
                            <div class="cust-mes">当前度电：{{chargeBalanceValue}}</div>
                            <el-form :model="dialogForm" label-width="120px" ref="dialogForm" :rules="pageConfig.selectFormRules">
                                <el-form-item :label="dialogLabel" prop="chargeNum">
                                    <!-- <el-input style="width:320px;" size="small" v-model="dialogForm.chargeNum" @input="changeRefund" autocomplete="off"></el-input> -->
                                     <el-input-number style="width:320px;" v-model="dialogForm.chargeNum" @change="changeRefund" :precision="2" :min="-999999.99" :max="999999.99" label="描述文字" :controls = "false" size="small" :step="0.1"></el-input-number>
                                </el-form-item>
                                <div class="red-tip" v-if="tipFlag">退款度电不得超过当前度电</div>
                                <el-form-item label="备注" prop="remark">
                                    <el-input style="width:320px;" size="small" v-model="dialogForm.remark" autocomplete="off"></el-input>
                                </el-form-item>
                            </el-form>
                            <div slot="footer" class="dialog-footer">
                                <el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
                                <el-button type="primary" size="small" @click="handleCustBehavior('dialogForm')">确 定</el-button>
                            </div>
                        </el-dialog>
                    </el-tab-pane>
                    <el-tab-pane label="订单流水" name="third">
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
    </div>
</template>

<script>
    import pageConfig from './page-config';
    export default {
        data() {
            return {
                pageConfig: pageConfig, // 页面配置
                tableData: [], // 表格数据
                selections: [], // 表格选项
                pagination: pageConfig.pagination,
                pageConfig,
                editFlag:false,
                pageTitle:'客户详情',
                // 默认值设置
                detailForm: {
                    remark: ''
                },
                custDto:{},
                queryInfo: {},
                dialogForm:{},
                activeName: 'first',
                operates: {
					width: 220,
					fixed: "right",
					list: [
					]
                }, // 列操作按钮 
                dialogFormVisible: false,
                dialogTitle:'',
                dialogLabel:'',
                actInExpAmount:'',
                recentInTime:'暂无充值记录',
                chargeBalanceValue: '',
                remarkShow: true,
                inputShow: false,
                btnShow: true,
                editShow: false,
                tipFlag: false,
                mobileLength:''
            }
        },
        methods: {
            init() {
                if(this.$store.state.editId){
                    this.editFlag = true;
                    this.getFormInfo();
                }
            },
            // 获取表单信息
            getFormInfo(){
                let _ = this;
                _.$H.post(_,_.$A.cust.cust,{custId:_.$store.state.editId}).then(res => {
                     _.detailForm = res.data.data;
                     _.custDto = res.data.data.custDto;
                     _.mobileLength = _.detailForm.mobile.length
                });
            },
            // 获取表格数据
            getListData(pagination, reload = false) {
                let _ = this;
                _.$U.showLoading(_);
                _.queryInfo.pageNum = pagination.current - 1;
                if (reload) {
                    _.queryInfo.pageNum = 0;
                }
                _.queryInfo.pageSize = pagination.pageSize;
                _.queryInfo.corpNo = _.$store.state.corpNo;
                _.queryInfo.userCustNo = _.detailForm.custNo || '';
                _.queryInfo.dealerNo = _.$store.state.userInfo.dealNo;
                _.queryInfo.chargeType = '02';
                _.$H.get(_, _.$A.cust.chargeCardList, _.queryInfo).then(res => {
                    _.tableData = res.data.data.content || [];
                    _.pagination.total = _.tableData.totalElements || 0;
                    _.$U.hideLoading(_);
                })
            },
            handleClick(tab, event) {
                if(tab.index == 1){
                    this.queryInfo.custNo = this.detailForm.custNo;
                    this.getListData(this.pagination,true);
                }
                else if(tab.index == 2){
                    let _ = this;
                    var url = _.$router.resolve({name: 'orderManageList',query: {mobile: _.detailForm.mobile}})
                    window.open(url.href,'_blank')
                }
                else{
                    this.init();
                }
                
            },
            handleCustRecharge(type){
                let _ = this;
                if(_.tableData.length > 0){
                   _.detailForm.custRemark = _.tableData[0].remark;
                   _.chargeBalanceValue = _.tableData[0].chargeBalanceValue;
                   _.recentInTime = _.tableData[0].lastModifiedWhen;
                }else{
                    _.actInExpAmount = 0;
                }
                _.dialogForm = {};
                this.tipFlag = false;
                this.dialogFormVisible = true;
                if(type == '1'){
                    _.dialogTitle = "客户充值";
                    _.dialogLabel = '充值（度电）';
                }else{
                    _.dialogTitle = "客户退款";
                    _.dialogLabel = '退款（度电）';
                }
            },
            handleCustBehavior(formName){
                let _ = this;
                //判断手机号是否输入正确
                // var strTemp = /(^[0-9]{1,6}$)|(^[0-9]{1,6}[\.]{1}[0-9]{1,2}$)/;
                // if (strTemp.test(_.dialogForm.chargeNum)) {
                // }else{
                //     _.$U.error('请输入正确的数据格式');
                //     return false;
                // }
                if(_.tableData.length > 0){
                   _.dialogForm.cardNo = _.tableData[0].cardNo || ''
                }else{
                    _.dialogForm.cardNo =  ''
                }
                _.detailForm.chargeValue = '';
                _.dialogForm.userCustNo = _.detailForm.custNo;
                _.dialogForm.dealNo = _.$store.state.userInfo.dealNo;
                _.dialogForm.lastModifiedByName = _.$store.state.userInfo.lastModifiedByName;
                _.dialogForm.dealerNo = _.$store.state.userInfo.dealNo;
                _.dialogForm.useredPhone = _.detailForm.mobile;
                _.dialogForm.transactionChannel = '06';
                if(_.dialogLabel == '充值（度电）'){
                    _.dialogForm.operateType = '01';
                    _.dialogForm.chargeValue = _.dialogForm.chargeNum
                }else if(_.dialogLabel == '退款（度电）'){
                    _.dialogForm.operateType = '07';
                    _.dialogForm.chargeValue = -_.dialogForm.chargeNum
                    if (Number(_.dialogForm.chargeNum) < 0) {
                        _.dialogForm.chargeValue = _.dialogForm.chargeNum
                    }

                    if (Number(_.dialogForm.chargeValue) < 0 && (Number(_.dialogForm.chargeValue) + Number(_.chargeBalanceValue) < 0)) {
                        _.$U.error("操作失败")
                        return
                    }
                }
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        _.$U.showLoading(_);
                        _.$H.post(_, _.$A.cust.addCardList, _.dialogForm).then(res => {
                            _.$U.success("操作成功")
                            _.dialogFormVisible = false;
                            _.getListData(_.pagination)
                            _.$U.hideLoading(_);
                        })
                    }
                });
            },
            changeRefund () {
                let _ = this;
                
                if(_.dialogLabel == '充值（度电）'){
                    return
                }

                let chargeValue = -_.dialogForm.chargeNum;
                if (Number(_.dialogForm.chargeNum) < 0) {
                    chargeValue = _.dialogForm.chargeNum
                }

                if (Number(chargeValue) < 0 && (Number(chargeValue) + Number(_.chargeBalanceValue) < 0)) {
                    _.tipFlag = true;
                } else {
                    _.tipFlag = false;
                }
            },
            openInput(){
                this.btnShow = false;
                this.editShow = true;
                this.remarkShow = false;
                this.inputShow = true;
                //this.detailForm.remark = '';
            },
            toEdit(){
                let _ = this;
                _.$U.showLoading(_);
                var obj = {};
                obj.lastModifiedByName = _.$store.state.userInfo.lastModifiedByName;
                obj.id = _.$store.state.editId;
                obj.remark = _.detailForm.remark;
                obj.mobile = _.detailForm.mobile;
                obj.custNo = _.detailForm.custNo;
                obj.editParam = 'custRemark';
                _.$H.post(_, _.$A.cust.targetremark, obj).then(res => {
                    _.$U.success("编辑成功")
                    _.btnShow = true;
                    _.editShow = false;
                    _.remarkShow = true;
                    _.inputShow = false;
                    _.getFormInfo();
                    _.$U.hideLoading(_);
                })
            }

        },
        mounted() {
            this.init();
        }
    }
</script>